import { aplicarContextoCultivoAoTalhao, contextoCultivoLegado } from '../services/ciclosCultivoService';

export function integrarTalhoesPermanentesNaIrrigacao(
  talhoes = [],
  configuracoes = [],
  contextosCultivo = new Map()
) {
  const configuracaoPorTalhao = new Map(
    configuracoes.map(configuracao => [String(configuracao.talhao_id), configuracao])
  );

  return talhoes.map(talhao => {
    const contexto = contextosCultivo.get(String(talhao.id)) || contextoCultivoLegado(talhao);
    const talhaoComCultivo = aplicarContextoCultivoAoTalhao(talhao, contexto);
    const configuracao = configuracaoPorTalhao.get(String(talhao.id)) || null;

    return {
      ...talhaoComCultivo,
      configuracao_irrigacao: configuracao ? [configuracao] : [],
    };
  });
}

export function applyCanonicalAreasToIrrigationBalances(items = [], canonicalPlots = []) {
  const canonicalAreaByPlotId = new Map(
    canonicalPlots
      .filter(plot => (
        plot?.id != null
        && plot.area !== null
        && plot.area !== undefined
        && String(plot.area).trim() !== ''
        && Number.isFinite(Number(plot.area))
      ))
      .map(plot => [String(plot.id), Number(plot.area)])
  );

  return items.map(item => {
    const plotId = item?.talhao?.id ?? item?.talhao_id;
    const canonicalArea = canonicalAreaByPlotId.get(String(plotId));
    if (!Number.isFinite(canonicalArea)) return item;

    return {
      ...item,
      talhao: item.talhao
        ? { ...item.talhao, area: canonicalArea }
        : item.talhao,
    };
  });
}
